import React, { useEffect, useMemo, useState } from "react";
import {
  StatusBarItemUtilities,
  SyncUiEventArgs,
  SyncUiEventDispatcher,
} from "@itwin/appui-react";
import { ConditionalStringValue } from "@itwin/appui-abstract";
import { Icon } from "@itwin/core-react";
import { FooterIndicator } from "@itwin/appui-layout-react";

import {
  AbstractStatusBarItemUtilities,
  CommonStatusBarItem,
  StatusBarSection,
} from "@itwin/appui-abstract";
import { StageUsage, UiItemsProvider } from "@itwin/appui-abstract";
import { cMessage } from "./Message";

export function StatusBarLabelAndIcon({
  icon,
  label,
}: {
  icon?: string | ConditionalStringValue;
  label?: string | ConditionalStringValue;
}) {
  const [iconSpec, setIconSpec] = useState(
    ConditionalStringValue.getValue(icon)
  );
  const [displayLabel, setDisplayLabel] = useState(
    ConditionalStringValue.getValue(label)
  );

  const syncIdsOfInterest = useMemo(() => {
    const ids: string[] = [];
    if (icon instanceof ConditionalStringValue) {
      ids.push(...icon.syncEventIds);
    }
    if (label instanceof ConditionalStringValue) {
      ids.push(...label.syncEventIds);
    }
    return ids;
  }, [icon, label]);

  useEffect(() => {
    const handleSyncUiEvent = (args: SyncUiEventArgs) => {
      if (0 === syncIdsOfInterest.length) return;
      if (
        syncIdsOfInterest.some((value: string): boolean =>
          args.eventIds.has(value.toLowerCase())
        )
      ) {
        if (icon instanceof ConditionalStringValue) {
          icon.refresh();
          setIconSpec(ConditionalStringValue.getValue(icon));
        }

        if (label instanceof ConditionalStringValue) {
          label.refresh();
          setDisplayLabel(ConditionalStringValue.getValue(label));
        }
      }
    };

    SyncUiEventDispatcher.onSyncUiEvent.addListener(handleSyncUiEvent);
    return () => {
      SyncUiEventDispatcher.onSyncUiEvent.removeListener(handleSyncUiEvent);
    };
  }, [icon, label, syncIdsOfInterest]);

  const iconPaddingClass = "nz-icon-padding-right"; //!!OA ???
  return (
    <FooterIndicator>
      {" "}
      {iconSpec && <Icon iconSpec={iconSpec} />}{" "}
      {displayLabel && <span style={{ padding: "10px" }}> {displayLabel}</span>}{" "}
    </FooterIndicator>
  );
}

export class cStatusBar implements UiItemsProvider {
  public readonly id = "StatusBarDisplay";

  public provideStatusBarItems(
    stageId: string,
    stageUsage: string
  ): CommonStatusBarItem[] {
    if ("DefaultFrontstage" !== stageId || stageUsage !== StageUsage.General)
      return [];

    const iconCondition = new ConditionalStringValue(
      () => cMessage.getStatusBarIcon(),
      [cMessage.statusBarEventId]
    );
    const labelCondition = new ConditionalStringValue(
      () => cMessage.getStatusBarMessage(),
      [cMessage.statusBarEventId]
    );
    const statusBarItem = StatusBarItemUtilities.createStatusBarItem(
      "StatusBarLabel-1",
      StatusBarSection.Center,
      100,
      <StatusBarLabelAndIcon icon={iconCondition} label={labelCondition} />
    );

    return [statusBarItem];
  }
}
